module.exports = __webpack_public_path__ + "static/media/182.fe6cd048.svg";